import React from 'react'
import PropTypes from 'prop-types'

export default function NextIcon(props) {
  let iconProps = {
    ...props,
    hovered: props.hovered.toString(),
  }
  let iconStyles = {
    color: '#404040',
    fill: '#fafafa'
  }
  if (props.disabled) {
    iconStyles = {
      color:'#5d5d5d',
      fill: '#404040'
    }
  } else if (props.hovered) {
    iconStyles = {
      color: '#f37735',
      fill: '#fafafa'
    }
  }
  iconProps = {
    ...iconProps,
    ...iconStyles
  }
  return (
    <svg width={iconProps.width} height={iconProps.height} viewBox='0 0 40 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...iconProps}>
      <rect y='0.5' width='40' height='33' rx='16' fill={iconProps.fill} />
      <path d='M21.1719 16.5002L16.2219 11.5502L17.6359 10.1362L23.9999 16.5002L17.6359 22.8642L16.2219 21.4502L21.1719 16.5002Z' fill={iconProps.color} />
    </svg>
  )
}

NextIcon.propTypes = {
  disabled: PropTypes.bool,
  height: PropTypes.number,
  hovered: PropTypes.bool,
  width: PropTypes.number
}

NextIcon.defaultProps = {
  disabled: false,
  height: 40,
  hovered: false,
  width: 40
}
